<script setup lang="ts">
const config = useRuntimeConfig()
const show = computed(() => (config.public.paymentMode as string) === 'subscription')
</script>

<template>
  <div v-if="show">
    <slot />
  </div>
</template>
